import { createScriptEle, objectToParams, paramsToObject } from './helpers';

export const SDK_SCRIPT_ELE_ID = 'facebook-jssdk';

export const FacebookLoginClient = {
  getFB: () => {
    if (!window.FB) {
      console.warn('FB not found');
      return null;
    }
    return window.FB;
  },
  getLoginStatus(
    callback,
    isForcingRoudtrip = false
  ) {
    const FB = this.getFB();

    if (!FB) {
      callback({ status: 'unknown'  });
      return;
    }

    FB.getLoginStatus(callback, isForcingRoudtrip);
  },
  getProfile(callback, params) {
    this.getFB()?.api('me', params, callback);
  },
  init(initParams) {
    this.getFB()?.init(initParams);
  },
  clear() {
    window.FB = null;
    const scriptEle = document.getElementById(SDK_SCRIPT_ELE_ID);
    if (scriptEle) {
      scriptEle.remove();
    }
  },
  isRedirected(dialogParams) {
    const params = paramsToObject(window.location.search);

    return (
      (params['state'] === dialogParams?.state ?? 'facebookdirect') &&
      params[dialogParams?.response_type ?? ''] !== undefined
    );
  },
  async loadSdk(language, useCustomerChat) {
    await createScriptEle(
      SDK_SCRIPT_ELE_ID,
      `https://connect.facebook.net/${language}/sdk${
        useCustomerChat ? '/xfbml.customerchat' : ''
      }.js`
    );
  },
  redirectToDialog(
    dialogParams,
    { ignoreSdkError, ...loginOptions }
  ) {
    window.location.href = `https://www.facebook.com/dialog/oauth${objectToParams(
      {
        ...dialogParams,
        ...loginOptions,
      }
    )}`;
  },
  login(
    callback,
    { ignoreSdkError, ...loginOptions }
  ) {
    try {
      this.getFB()?.login(callback, loginOptions);
    } catch (e) {
      if (ignoreSdkError) {
        return;
      } else {
        throw e;
      }
    }
  },
  logout(callback) {
    this.getLoginStatus((res) => {
      if (res.status === 'connected') {
        this.getFB()?.logout(callback);
      } else {
        callback();
      }
    });
  },
};
